import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";

const format =  d3.format(".2s"); 

const XAxis = ({ bottom, left, height, scale }) => {
  const axis = useRef(null) as any;

  useEffect(() => {
    d3.select(axis.current).call(d3.axisBottom(scale).tickSizeOuter(0));
  });

  return (
    <g
      className="axis x"
      ref={axis}
      transform={`translate(${left}, ${height - bottom})`}
    />
  );
};

const YAxis = ({ top, left, scale }) => {
  const axis = useRef(null);

  useEffect(() => {
    d3.select(axis.current).call(d3.axisLeft(scale).tickSizeOuter(0));
  });

  return (
    <g className="axis y" ref={axis} transform={`translate(${left}, ${top})`} />
  );
};

const Rect = ({ data, x, y, height, top, bottom, BCColors }) => {
  return (
    <g transform={`translate(${x(data.date)}, ${y(data.value)})`}>
      <rect
        width={x.bandwidth()}
        height={height - bottom - top - y(data.value)}
        fill={BCColors[data.index]}
      />
      <text
        transform={`translate(${x.bandwidth() / 2}, ${-2})`}
        textAnchor="middle"
        alignmentBaseline="baseline"
        fill="grey"
        fontSize="10"
      >
        {format(data.value)}
      </text>
    </g>
  );
};

const Bar = props => {
  const [sort] = useState(false);

  const data = sort
    ? [...props.data].sort((a, b) => b.value - a.value)
    : [...props.data];

  const x = d3
    .scaleBand()
    .range([0, props.width - props.left - props.right])
    .domain(data.map(d => d.date))
    .padding(0.1);

  const y = d3
    .scaleLinear()
    .range([props.height - props.top - props.bottom, 0])
    .domain([0, d3.max(data, d => d.value)]);

  return (
      <svg  viewBox={`0, 0, ${props.width + 5}, ${props.height + ((props.xLabel) ? 40 : 20)}`} >
        <XAxis
          scale={x}
          bottom={props.bottom}
          left={props.left}
          height={props.height}
        />
        <YAxis
          scale={y}
          top={props.top}
          left={props.left}
        />
        <g transform={`translate(${props.left}, ${props.top})`}>
          {data.map((d, i) => (
            <Rect
              key={`rect-${i}`}
              data={d}
              x={x}
              y={y}
              top={props.top}
              bottom={props.bottom}
              height={props.height}
              BCColors={props.graphColors}
            />
          ))}
        </g>
        {props.xLabel && 
          <text 
            style={{  textAnchor: "middle", fontSize: "12px", textDecoration: "bold"}} 
            x={props.height - 20} 
            y={props.height + (props.xLabel ? 20 : 20)} 
            fontFamily="Verdana">
            {props.xLabel}
          </text>} 
        {props.yLabel && 
          <text 
            transform="rotate(-90)"
            style={{textAnchor: "middle", fontSize: "12px", textDecoration: "bold"}} 
            x={props.height / 2 * -1} 
            y={20} 
            fontFamily="Verdana">
            {props.yLabel}
          </text>}
      </svg>
    
  );
};

export default Bar;
